<agpr-take-over-panel
    id="chartDrillDownDialog"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="close($event)"
    [width]="100"
    [hasSideTabs]="true"
    [showFooter]="false"
    invisibleHeader="Reports.chartDrillDownDialog.title"
>
    <div class="agpr-chartDrillDownDialog">
        <agpr-transition-card-tabs
            [selectedTabIndex]="selectedTabIndex"
            [orientation]="tabsOrientationsEnum.VERTICAL"
            [isCardView]="selectedTabIndex === chartDrillDownTabEnum.dashboard"
            (selectedTabIndexChange)="tabIndexChange($event)"
        >
            <agpr-tab
                [id]="tabIds.DASHBOARD"
                [icon]="tabIcons.DASHBOARD"
                [hideTabShowContent]="selectedTabIndex === chartDrillDownTabEnum.dashboard"
                [tooltip]="'Reports.chartDrilldownDialog.dashboard.tooltip'"
                [showSpacer]="true"
            >
                <div class="agpr-chartDrillDownDialog-dashboard agpr-chartDrillDownDialog-section">
                    <agpr-scroll-panel>
                        <ng-container *ngTemplateOutlet="chartTemplate; context: { am5c: am5Charts[chartDrillDownTabEnum.dashboard], tabIndex: chartDrillDownTabEnum.dashboard }"></ng-container>
                        <ng-container *ngTemplateOutlet="sourcePicker; context: { suffix: '.dashboard'}"></ng-container>

                        <div class="agpr-chartDrillDownDialog-row">
                            <div class="agpr-chartDrillDownDialog-row-title">
                                {{ 'Reports.chartDrilldownDialog.coverageDetails' | localize }}
                            </div>
                            <div class="agpr-chartDrillDownDialog-row-cards">
                                <agpr-card-chart
                                    class="agpr-chartDrillDownDialog-smallChart-top"
                                    [series]="[totalVolumeSeries, previousPeriodTotalVolumeSeries]"
                                    [color]="cardChartComponentHighlightColorEnum.volume"
                                    [bubbleTooltipMetric]="socialMetrics.VOLUME"
                                    [headingLevel]="4"
                                >
                                </agpr-card-chart>
                                <agpr-card-chart
                                    class="agpr-chartDrillDownDialog-smallChart-top"
                                    [series]="[totalImpressionsSeries, previousPeriodTotalImpressionsSeries]"
                                    [color]="cardChartComponentHighlightColorEnum.impressions"
                                    [bubbleTooltipMetric]="socialMetrics.IMPRESSIONS"
                                    [headingLevel]="4"
                                >
                                </agpr-card-chart>
                                <agpr-card-chart
                                    class="agpr-chartDrillDownDialog-smallChart-top"
                                    [series]="[totalAveSeries, previousPeriodTotalAveSeries]"
                                    [color]="cardChartComponentHighlightColorEnum.engagements"
                                    [showCurrency]="true"
                                    [bubbleTooltipMetric]="socialMetrics.AVE"
                                    [headingLevel]="4"
                                >
                                </agpr-card-chart>
                            </div>
                        </div>

                        <div class="agpr-chartDrillDownDialog-row">
                            <div class="agpr-chartDrillDownDialog-row-title">
                                {{ 'Reports.chartDrilldownDialog.coverageSentiment' | localize }}
                            </div>
                            <div class="agpr-chartDrillDownDialog-row-cards">
                                <agpr-card-chart
                                    class="agpr-chartDrillDownDialog-smallChart-top"
                                    [series]="[totalPositiveSeries, previousPeriodTotalPositiveSeries]"
                                    [color]="cardChartComponentHighlightColorEnum.positive"
                                    [bubbleTooltipMetric]="socialMetrics.POSITIVE"
                                    [headingLevel]="4"
                                >
                                </agpr-card-chart>
                                <agpr-card-chart
                                    class="agpr-chartDrillDownDialog-smallChart-top"
                                    [series]="[totalNeutralSeries, previousPeriodTotalNeutralSeries]"
                                    [color]="cardChartComponentHighlightColorEnum.neutral"
                                    [bubbleTooltipMetric]="socialMetrics.NEUTRAL"
                                    [headingLevel]="4"
                                >
                                </agpr-card-chart>
                                <agpr-card-chart
                                    class="agpr-chartDrillDownDialog-smallChart-top"
                                    [series]="[totalNegativeSeries, previousPeriodTotalNegativeSeries]"
                                    [color]="cardChartComponentHighlightColorEnum.negative"
                                    [bubbleTooltipMetric]="socialMetrics.NEGATIVE"
                                    [headingLevel]="4"
                                >
                                </agpr-card-chart>
                            </div>
                        </div>
                    </agpr-scroll-panel>
                </div>
            </agpr-tab>
            <agpr-tab
                [id]="tabIds.MENTION"
                [icon]="selectedTabIndex === chartDrillDownTabEnum.mentionList ? tabIcons.MENTION_SELECTED : tabIcons.MENTION"
                [heading]="'Reports.chartDrilldownDialog.viewCoverage.header'"
                [description]="'Reports.chartDrilldownDialog.viewCoverage.description'"
                [tooltip]="'Reports.chartDrilldownDialog.viewCoverage.description'"
            >
                <div class="agpr-chartDrillDownDialog-splitSection">
                    <div class="agpr-chartDrillDownDialog-section">
                        <div>
                            <ng-container *ngTemplateOutlet="sourcePicker; context: { suffix: '.section'}"></ng-container>
                        </div>
                        <agpr-scroll-panel>
                            <ng-container *ngTemplateOutlet="chartTemplate; context: { am5c: am5Charts[chartDrillDownTabEnum.mentionList], tabIndex: chartDrillDownTabEnum.mentionList }"></ng-container>
                        </agpr-scroll-panel>
                    </div>
                    <div class="agpr-chartDrillDownDialog-section-maxWidth">
                        <div class="agpr-chartDrillDownDialog-mentions">
                            <agpr-mention-search-result
                                header="Reports.chartDetailsDialog.mentions"
                                [showActionBar]="false"
                                [reGetCardHeight]="selectedTabIndex === chartDrillDownTabEnum.mentionList"
                                [dateFilterOptions]="dateFilterOptions$ | async"
                                [dateTypeFilterOptions]="dateTypeFilterOptions$ | async"
                                [showFilterLock]="false"
                                [ignoreReset]="true"
                                [requireCombinedQueryResults]="true"
                                (dateChanged)="dateChanged($event)"
                                (contactClicked)="mentionCardClicked({ eventType: 'contact', mention: $event })"
                                (outletClicked)="mentionCardClicked({ eventType: 'outlet', mention: $event })"
                                (mentionCardClicked)="mentionCardClicked({ eventType: 'mention', mention: $event })"
                                (selectedMentionsChange)="selectedMentions = $event"
                                [showMentionViewIcon]="true"
                            >
                            </agpr-mention-search-result>
                        </div>
                        <div class="agpr-chartDrillDownDialog-mentions-footer">
                            <agpr-action-bar
                                [headingContext]="'Reports.chartDetailsDialog.monitor' | localize"
                            >
                                <ng-template #right>
                                    @if (source && savedSources.includes(source?.type)) {
                                        <agpr-button
                                            id="Reports_chartDetailsDialog_bulkActionButton"
                                            label="Monitoring.result.bulkActionButtonLabel"
                                            [style]="buttonTypes.primaryB"
                                            (click)="openBulkDialog()"
                                        ></agpr-button>
                                    }
                                    <agpr-button
                                        id="Reports.chartDetailsDialog.monitor"
                                        label="Reports.chartDetailsDialog.monitor"
                                        [style]="buttonTypes.secondary"
                                        (click)="navigateToMonitor()"
                                    ></agpr-button>
                                </ng-template>
                            </agpr-action-bar>
                        </div>
                    </div>
                </div>
            </agpr-tab>
            @if (hasTargeting) {
                <agpr-tab
                    [id]="tabIds.CONTACT_OUTLET"
                    [icon]="selectedTabIndex === chartDrillDownTabEnum.contactOutletList ? tabIcons.CONTACT_OUTLET_SELECTED : tabIcons.CONTACT_OUTLET"
                    [heading]="'Reports.chartDrilldownDialog.contactOutlets.header'"
                    [description]="'Reports.chartDrilldownDialog.contactOutlets.description'"
                    [tooltip]="'Reports.chartDrilldownDialog.contactOutlets.description'"
                >
                    <div class="agpr-chartDrillDownDialog-splitSection">
                        <div class="agpr-chartDrillDownDialog-section">
                            <div>
                                <ng-container *ngTemplateOutlet="sourcePicker; context: { suffix: '.splitSection'}"></ng-container>
                            </div>
                            <agpr-scroll-panel>
                                <ng-container *ngTemplateOutlet="chartTemplate; context: { am5c: am5Charts[chartDrillDownTabEnum.contactOutletList], tabIndex: chartDrillDownTabEnum.contactOutletList }"></ng-container>
                            </agpr-scroll-panel>
                        </div>
                        <div class="agpr-chartDrillDownDialog-section-maxWidth">
                            <agpr-right-sidebar
                                #rightSidebar
                                class="agpr-chartDrillDownDialog-rightSideBar"
                                [showTabTitle]="false"
                                (selectedTabIndexChange)="tabChangeContactOutlet($event)"
                            >
                                <agpr-entity-list-tab
                                    [id]="'targetingRhpTab.viewAllContacts'"
                                    [entityMode]="entityType.CONTACT"
                                    [heading]="'Reports.chartDetailsDialog.mentionContacts'| localize"
                                    [tooltip]="'Reports.chartDetailsDialog.mentionContacts' | localize"
                                    (showRhpTakeOver)="openTargetingEntityTakeover($event)"
                                ></agpr-entity-list-tab>
                                <agpr-entity-list-tab
                                    [id]="'targetingRhpTab.viewAllOutlets'"
                                    [entityMode]="entityType.OUTLET"
                                    [heading]="'Reports.chartDetailsDialog.mentionOutlets' | localize"
                                    [tooltip]="'Reports.chartDetailsDialog.mentionOutlets' | localize"
                                    (showRhpTakeOver)="openTargetingEntityTakeover($event)"
                                ></agpr-entity-list-tab>
                            </agpr-right-sidebar>
                        </div>
                    </div>
                </agpr-tab>
            }
            @if(!isRefMediaAccount) {
                <agpr-tab
                    [id]="tabIds.COVERAGE_INSIGHTS"
                    [icon]="selectedTabIndex === chartDrillDownTabEnum.coverageInsights ? tabIcons.COVERAGE_INSIGHTS_SELECTED : tabIcons.COVERAGE_INSIGHTS"
                    [heading]="'Reports.chartDrilldownDialog.coverageInsights.header'"
                    [description]="'Reports.chartDrilldownDialog.coverageInsights.description'"
                    [tooltip]="'Reports.chartDrilldownDialog.coverageInsights.description'"
                >
                    <agpr-coverage-insight
                        [drilldownSeries]="drilldownSeries"
                        [coverageInsightConfig]="coverageInsightConfig"
                        [externalKeyMessageGroups]="sharedKeyMessageGroups"
                        [isActive]="isCoverageInsightActive"
                        (keyMessageGroupsChanged)="onKeyMessageGroupsChanged($event)"
                        (dateChanged)="dateChanged($event)"
                        (emitSourceChanged)="sourceChanged($event)"
                    >
                    </agpr-coverage-insight>
                </agpr-tab>
                <agpr-tab
                    [id]="tabIds.ACTION_ASSISTANT"
                    [icon]="selectedTabIndex === chartDrillDownTabEnum.actionAssistant ? tabIcons.ACTION_ASSISTANT_SELECTED : tabIcons.ACTION_ASSISTANT"
                    [heading]="'Reports.chartDrilldownDialog.actionAssistant.header'"
                    [description]="'Reports.chartDrilldownDialog.actionAssistant.description'"
                    [tooltip]="'Reports.chartDrilldownDialog.actionAssistant.description'"
                >
                    <agpr-action-assistant
                        [drilldownSeries]="drilldownSeries"
                        [coverageInsightConfig]="coverageInsightConfig"
                        [externalKeyMessageGroups]="sharedKeyMessageGroups"
                        (keyMessageGroupsChanged)="onKeyMessageGroupsChanged($event)"
                        (dateChanged)="dateChanged($event)"
                        (emitSourceChanged)="sourceChanged($event)"
                    >
                    </agpr-action-assistant>
                </agpr-tab>
            }

        </agpr-transition-card-tabs>
    </div>
</agpr-take-over-panel>

<ng-template #sourcePicker let-suffix="suffix">
    <div class="agpr-chartDrillDownDialog-sourcePicker">
        <agpr-chart-drilldown-source-picker
            [id]="id + suffix + '.mention_source_picker'"
            [(ngModel)]="drilldownSeries"
            [showFilterButton]="selectedTabIndex !== chartDrillDownTabEnum.mentionList"
            [showFiltersBeside]="selectedTabIndex === chartDrillDownTabEnum.dashboard"
            [showDateRange]="selectedTabIndex === chartDrillDownTabEnum.dashboard || selectedTabIndex === chartDrillDownTabEnum.contactOutletList"
            [showDateRangeBelow]="selectedTabIndex === chartDrillDownTabEnum.contactOutletList"
            (ngModelChange)="sourceChanged($event)"
            (dateChanged)="dateChanged($event)"
            (filtersApplied)="filtersApplied()"
        ></agpr-chart-drilldown-source-picker>
    </div>
</ng-template>

<ng-template #chartTemplate let-am5c="am5c" let-tabIndex="tabIndex">
    <div [agprLoading]="changingSource"
        class="agpr-chartDrillDownDialog-chartArea"
        [ngClass]="{'agpr-chartDrillDownDialog-chartArea-lessTopSpacing': selectedTabIndex !== chartDrillDownTabEnum.dashboard}"
    >
        <div [ngStyle]="{'width': '100%', 'min-width': (selectedTabIndex === chartDrillDownTabEnum.dashboard ? blockWidth : 460) + 'px', 'height': blockHeight + 'px'}">
            @if (!changingSource) {
                @if (chart && !am5c) {
                    <div class="agpr-chartDrillDownDialog-chartArea-container">
                        @if (chartNoData) {
                            <agpr-message
                                class="agpr-chartDrillDownDialog-noContentMessage"
                                [severity]="messageSeverities.noContent"
                            >
                                {{ 'Monitor.MAD.chart.noContentLabel' | localize }}
                            </agpr-message>
                        }
                        <agpr-reports-chart
                            [showLoadingUntil]="chartLoadingOptionsEnum.any"
                            [chart]="chart"
                            (noContent)="updateChartNoData($event)"
                        ></agpr-reports-chart>
                    </div>
                } @else if (block) {
                    <!-- as of right now, only needed for top terms -->
                    <agpr-block-wrapper
                        [block]="block"
                        [actionable]="false"
                    ></agpr-block-wrapper>
                } @else if (chartGroup) {
                    <div
                        class="agpr-chartDetailsDialog-chartAreaContainer"
                        [ngStyle]="{'height': blockHeight + 'px'}"
                    >
                        <agpr-chart-group
                            [showLoadingUntil]="chartLoadingOptionsEnum.any"
                            [charts]="chartGroup"
                            [id]="id"
                        ></agpr-chart-group>
                    </div>
                } @else if (am5c) {
                    <div class="agpr-chartDrillDownDialog-chartArea-container">
                        @if (chartNoData) {
                            <agpr-message
                                class="agpr-chartDrillDownDialog-noContentMessage"
                                [severity]="messageSeverities.noContent"
                            >
                                {{ 'Monitor.MAD.chart.noContentLabel' | localize }}
                            </agpr-message>
                        }
                        @if (selectedTabIndex === tabIndex) {
                            <agpr-am5-chart
                                #am5ChartComponent
                                [chart]="am5c"
                                [series]="useDrilldownSeries ? [drilldownSeries] : reportSeries"
                                (noData)="updateChartNoData($event)"
                                (tooltipLinkClick)="drillDownAm5Chart($event)"
                            ></agpr-am5-chart>
                        }
                    </div>
                } @else {
                    <div class="agpr-chartDrillDownDialog-chartArea-container">
                        <agpr-message
                            class="agpr-chartDrillDownDialog-noContentMessage"
                            [severity]="messageSeverities.noContent"
                        >
                            {{ 'Monitor.MAD.chart.noContentLabel' | localize }}
                        </agpr-message>
                    </div>
                }
            }
            <div #customChartLegend class="agpr-chartDrillDownDialog-customLegendContainer"></div>
        </div>
    </div>
</ng-template>
